"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingSelector = exports.errorSelector = exports.trustedDomainsSelector = exports.persistTrustedDomains = exports.fetchTrustedDomains = exports.replaceTrustedDomainsFailure = exports.replaceTrustedDomainsSuccess = exports.replaceTrustedDomains = exports.getTrustedDomainsFailure = exports.getTrustedDomainsSuccess = exports.getTrustedDomains = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var _i18n_1 = __importDefault(require("@i18n"));
var notifier_1 = __importDefault(require("@utils/notifier"));
var apiService_1 = __importStar(require("@common/services/apiService"));
var initialState = {
    data: [],
    loading: false,
    error: null,
    updating: false,
};
var trustedDomains = (0, toolkit_1.createSlice)({
    name: 'trustedDomains',
    initialState: initialState,
    reducers: {
        getTrustedDomains: function (state) {
            state.loading = true;
        },
        getTrustedDomainsSuccess: function (state, _a) {
            var payload = _a.payload;
            state.data = payload;
            state.loading = false;
            state.error = null;
        },
        getTrustedDomainsFailure: function (state, _a) {
            var payload = _a.payload;
            state.loading = false;
            state.error = payload;
        },
        replaceTrustedDomains: function (state) {
            state.loading = true;
        },
        replaceTrustedDomainsSuccess: function (state, _a) {
            var payload = _a.payload;
            state.data = payload;
            state.loading = false;
            state.error = null;
        },
        replaceTrustedDomainsFailure: function (state, _a) {
            var payload = _a.payload;
            state.loading = false;
            state.error = payload;
        },
    },
});
exports.getTrustedDomains = (_a = trustedDomains.actions, _a.getTrustedDomains), exports.getTrustedDomainsSuccess = _a.getTrustedDomainsSuccess, exports.getTrustedDomainsFailure = _a.getTrustedDomainsFailure, exports.replaceTrustedDomains = _a.replaceTrustedDomains, exports.replaceTrustedDomainsSuccess = _a.replaceTrustedDomainsSuccess, exports.replaceTrustedDomainsFailure = _a.replaceTrustedDomainsFailure;
function fetchTrustedDomains(domain) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, error_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.getTrustedDomains)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.getTrustedDomains({ domain: domain })];
                case 2:
                    data = (_a.sent()).data;
                    dispatch((0, exports.getTrustedDomainsSuccess)(data));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if ((0, apiService_1.isApiError)(error_1)) {
                        errorMessage = _i18n_1.default.t('settings:SECURITY.GET_TRUSTED_DOMAINS_FAILURE_MESSAGE');
                        dispatch((0, exports.getTrustedDomainsFailure)(errorMessage));
                        notifier_1.default.error(errorMessage, error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
exports.fetchTrustedDomains = fetchTrustedDomains;
function persistTrustedDomains(domain, trustedDomains) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.replaceTrustedDomains)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.patchTrustedDomain({ domain: domain }, { trustedDomains: trustedDomains })];
                case 2:
                    data = (_a.sent()).data;
                    notifier_1.default.success(_i18n_1.default.t('settings:SAVE_SUCCESS_MESSAGE'));
                    dispatch((0, exports.replaceTrustedDomainsSuccess)(data));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    if ((0, apiService_1.isApiError)(error_2)) {
                        notifier_1.default.error(_i18n_1.default.t('settings:SAVE_FAILURE_MESSAGE'), error_2);
                        dispatch((0, exports.replaceTrustedDomainsFailure)(error_2.message));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
exports.persistTrustedDomains = persistTrustedDomains;
exports.default = trustedDomains.reducer;
var trustedDomainsSelector = function (state) { return state.currentTeam.settings.trustedDomains.data; };
exports.trustedDomainsSelector = trustedDomainsSelector;
var errorSelector = function (state) { return state.currentTeam.settings.trustedDomains.error; };
exports.errorSelector = errorSelector;
var loadingSelector = function (state) { return state.currentTeam.settings.trustedDomains.loading; };
exports.loadingSelector = loadingSelector;
